import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { xlsxLangList } from './locales'
import { languageConfigList, i18nConfig } from '@/i18n/config.js'
// const { languageConfigList, i18nConfig }: any = langConfig
const i18nextInstance = i18next.createInstance()
i18nextInstance.use(initReactI18next)
const resources: any = {}
languageConfigList.forEach((item) => {
  xlsxLangList.forEach((langItem: any, index: number) => {
    if (!resources[item.value]) {
      resources[item.value] = {
        translation: {},
      }
    }
    Object.assign(resources[item.value].translation, langItem[item.value]?.translation || {})
  })
  resources[item.value] = {
    ...resources[item.value],
  }
})
console.log(resources)
i18nextInstance.init(
  {
    lng: localStorage.getItem(i18nConfig.langLocalName) || i18nConfig.defaultLang,
    fallbackLng: i18nConfig.fallbackLng || [],
    // debug: process.env.NODE_ENV === "development",
    ns: ['translation'],
    defaultNS: 'translation',
    resources: resources,
  },
  (err) => {
    if (err) return console.log('something went wrong loading', err)
  },
)

export default i18nextInstance
